import {
  FETCH_ASSEMBLY_DATA,
  SET_ASSEMBLY_DATA,
  SET_ASSEMBLY_DATA_FAILURE,
  CLEAR_ASSEMBLY_DATA,
  FETCH_ASSEMBLY_DETAILS,
  SET_ASSEMBLY_DETAILS,
  SET_ASSEMBLY_DETAILS_FAILURE,
  CLEAR_ASSEMBLY_DETAILS,
  UPLOAD_NDT_DOCUMENT,
  SET_NDT_UPLOAD_SUCCESS,
  SET_NDT_UPLOAD_FAILURE,
  UPDATE_ASSEMBLY_STATUS,
  SET_ASSEMBLY_STATUS_SUCCESS,
  SET_ASSEMBLY_STATUS_FAILURE,
  FETCH_ASSEMBLY_FILTERS,
  SET_ASSEMBLY_FILTERS,
  SET_ASSEMBLY_FILTERS_FAILURE,
  UPDATE_ASSEMBLY_FITMENT,
  SET_ASSEMBLY_FITMENT_SUCCESS,
  SET_ASSEMBLY_FITMENT_FAILURE,
  UPDATE_ASSEMBLY_VISUAL_INSPECTION,
  SET_ASSEMBLY_VISUAL_INSPECTION_SUCCESS,
  SET_ASSEMBLY_VISUAL_INSPECTION_FAILURE,
  UPDATE_ASSEMBLY_ALIGNMENT,
  SET_ASSEMBLY_ALIGNMENT_SUCCESS,
  SET_ASSEMBLY_ALIGNMENT_FAILURE,
  FETCH_GPS_DATA,
  SET_GPS_DATA,
  SET_GPS_DATA_FAILURE,
  CLEAR_GPS_DATA,
  FETCH_PRODUCTION_DATA,
  SET_PRODUCTION_DATA,
  SET_PRODUCTION_DATA_FAILURE,
  CLEAR_PRODUCTION_DATA,
  GET_ALL_TEAM_MEMBERS,
  SET_TEAM_MEMBERS,
  SET_TEAM_MEMBERS_FAILURE,
  CLEAR_TEAM_MEMBERS,
  FETCH_LIMITS_DATA,
  SET_LIMITS_DATA,
  SET_LIMITS_DATA_FAILURE,
  CLEAR_LIMITS_DATA,
  UPDATE_STATUS_CONFIGURATION,
  SET_STATUS_CONFIGURATION_SUCCESS,
  SET_STATUS_CONFIGURATION_FAILURE,
  FETCH_WELD_PARAMETERS,
  SET_WELD_PARAMETERS,
  SET_WELD_PARAMETERS_FAILURE,
  CLEAR_WELD_PARAMETERS,
  SET_WELD_PARAMETERS_MODAL_OPEN,
  DOWNLOAD_FITMENT_REPORT,
  SET_FITMENT_REPORT_DOWNLOAD_SUCCESS,
  SET_FITMENT_REPORT_DOWNLOAD_FAILURE,
  CLEAR_FITMENT_REPORT_DOWNLOAD,
  DOWNLOAD_VISUAL_INSPECTION_REPORT,
  SET_VISUAL_INSPECTION_REPORT_DOWNLOAD_SUCCESS,
  SET_VISUAL_INSPECTION_REPORT_DOWNLOAD_FAILURE,
  CLEAR_VISUAL_INSPECTION_REPORT_DOWNLOAD,
  DOWNLOAD_ALIGNMENT_REPORT,
  SET_ALIGNMENT_REPORT_DOWNLOAD_SUCCESS,
  SET_ALIGNMENT_REPORT_DOWNLOAD_FAILURE,
  CLEAR_ALIGNMENT_REPORT_DOWNLOAD,
  DOWNLOAD_PRODUCTION_SHEET_MERGED_REPORT,
  SET_PRODUCTION_SHEET_MERGED_REPORT_DOWNLOAD_SUCCESS,
  SET_PRODUCTION_SHEET_MERGED_REPORT_DOWNLOAD_FAILURE,
  CLEAR_PRODUCTION_SHEET_MERGED_REPORT_DOWNLOAD,
  DOWNLOAD_PRODUCTION_SHEET_MAIN_REPORT,
  SET_PRODUCTION_SHEET_MAIN_REPORT_DOWNLOAD_SUCCESS,
  SET_PRODUCTION_SHEET_MAIN_REPORT_DOWNLOAD_FAILURE,
  CLEAR_PRODUCTION_SHEET_MAIN_REPORT_DOWNLOAD,
  FETCH_NDT_INDICATION_LOGS,
  SET_NDT_INDICATION_LOGS,
  SET_NDT_INDICATION_LOGS_FAILURE,
  CLEAR_NDT_INDICATION_LOGS,
  CREATE_NDT_REPAIR_LOG,
  SET_CREATE_NDT_REPAIR_LOG_SUCCESS,
  SET_CREATE_NDT_REPAIR_LOG_FAILURE,
  UPDATE_NDT_REPAIR_LOG,
  SET_UPDATE_NDT_REPAIR_LOG_SUCCESS,
  SET_UPDATE_NDT_REPAIR_LOG_FAILURE,
  DELETE_NDT_REPAIR_LOG,
  SET_DELETE_NDT_REPAIR_LOG_SUCCESS,
  SET_DELETE_NDT_REPAIR_LOG_FAILURE,
  FETCH_NDT_REPAIR_LOG_DOC,
  SET_NDT_REPAIR_LOG_DOC,
  SET_NDT_REPAIR_LOG_DOC_FAILURE,
  UPLOAD_NDT_REPAIR_LOG_DOC,
  SET_NDT_REPAIR_LOG_DOC_SUCCESS,
  CLEAR_NDT_REPAIR_LOG_DOC,
  FETCH_NDT_CATEGORIES,
  SET_NDT_CATEGORIES,
  SET_NDT_CATEGORIES_FAILURE,
  GENERATE_PROJECT_PRODUCTION_SHEET_REPORT,
  SET_PROJECT_PRODUCTION_SHEET_REPORT_SUCCESS,
  SET_PROJECT_PRODUCTION_SHEET_REPORT_FAILURE,
  CLEAR_PROJECT_PRODUCTION_SHEET_REPORT,
  GENERATE_REPORT_ASSEMBLY,
  SET_GENERATE_REPORT_ASSEMBLY_SUCCESS,
  SET_GENERATE_REPORT_ASSEMBLY_FAILURE,
  CLEAR_GENERATE_REPORT_ASSEMBLY,
  GENERATE_IRN_REPORT,
  SET_IRN_REPORT_SUCCESS,
  SET_IRN_REPORT_FAILURE,
  CLEAR_IRN_REPORT,
  GET_IRN_REPORT_VERSIONS,
  GET_IRN_REPORT_VERSIONS_SUCCESS,
  GET_IRN_REPORT_VERSIONS_FAILURE,
  GET_PRODUCTION_REPORT_VERSIONS,
  GET_PRODUCTION_REPORT_VERSIONS_SUCCESS,
  GET_PRODUCTION_REPORT_VERSIONS_FAILURE,
  GENERATE_PROJECT_REPORT,
  GENERATE_PROJECT_REPORT_SUCCESS,
  GENERATE_PROJECT_REPORT_FAILURE,
  CLEAR_GENERATE_PROJECT_REPORT,
  GET_PROJECT_REPORT_VERSIONS,
  GET_PROJECT_REPORT_VERSIONS_SUCCESS,
  GET_PROJECT_REPORT_VERSIONS_FAILURE,
  DELETE_REPAIR_WELD,
  SET_DELETE_REPAIR_WELD_SUCCESS,
  SET_DELETE_REPAIR_WELD_FAILURE,
  CLEAR_DELETE_REPAIR_WELD,
  PRODUCTION_SHEET_SAVE_SIGNATURE,
  SET_PRODUCTION_SHEET_SAVE_SIGNATURE_SUCCESS,
  SET_PRODUCTION_SHEET_SAVE_SIGNATURE_FAILURE,
  CLEAR_PRODUCTION_SHEET_SAVE_SIGNATURE,
  FETCH_ARK_REGISTRY_DOCS,
  SET_ARK_REGISTRY_DOCS,
  SET_ARK_REGISTRY_DOCS_FAILURE,
  UPLOAD_ARK_REGISTRY_DOC,
  SET_ARK_REGISTRY_DOC_SUCCESS,
  DELETE_ARK_REGISTRY_DOC,
  SET_DELETE_ARK_REGISTRY_DOC_SUCCESS,
  SET_DELETE_ARK_REGISTRY_DOC_FAILURE,
  CLEAR_ARK_REGISTRY_DOCS,
  GET_ARK_REGISTRY_DOWNLOAD_URL,
  SET_ARK_REGISTRY_DOWNLOAD_URL,
  GET_ARK_REGISTRY_PRESIGNED_URL,
  SET_ARK_REGISTRY_PRESIGNED_URL
} from './types';

const initialState = {
  // Assembly Data
  assemblyData: [],
  assemblyTotalCount: 0,
  assemblyLoading: false,
  assemblyError: null,
  
  // Assembly Details
  assemblyDetails: {},
  assemblyDetailsLoading: false,
  assemblyDetailsError: null,
  
  // NDT Upload
  ndtUploadLoading: false,
  ndtUploadError: null,
  
  // Assembly Status Update
  statusUpdateLoading: false,
  statusUpdateError: null,
  statusUpdateSuccess: false,
  
  // Assembly Filters
  assemblyFilters: {
    statuses: [],
    stages: [],
    dateRanges: []
  },
  filtersLoading: false,
  filtersError: null,
  
  // Assembly Fitment Data
  fitmentUpdateLoading: false,
  fitmentUpdateError: null,
  fitmentUpdateSuccess: false,

  // Assembly Visual Inspection Data
  visualInspectionUpdateLoading: false,
  visualInspectionUpdateError: null,
  visualInspectionUpdateSuccess: false,

  // Assembly Alignment Data
  alignmentUpdateLoading: false,
  alignmentUpdateError: null,
  alignmentUpdateSuccess: false,

  // GPS Data
  gpsData: [],
  gpsLoading: false,
  gpsError: null,
  // Production Data
  productionData: {},
  productionDataLoading: false,
  productionDataError: null,
  productionDataSuccess: false,
  
  // Team Members
  teamMembers: [],
  teamMembersLoading: false,
  teamMembersError: null,
  
  // Limits Data
  limitsData: [],
  limitsLoading: false,
  limitsError: null,
  statusCalculationMethod: 'Instantaneous', // Default status calculation method
  
  // Status Configuration
  statusConfiguration: {},
  statusConfigurationLoading: false,
  statusConfigurationError: null,
  statusConfigurationSuccess: false,
  
  // Weld Parameters
  weldParameters: {},
  weldParametersLoading: false,
  weldParametersError: null,
  weldParametersModalOpen: false,
  weldParametersMachineType: null, // 'p625' or 'm500'
  
  // Fitment Report Download
  fitmentReportDownloadLoading: false,
  fitmentReportDownloadData: null,
  fitmentReportDownloadError: null,
  
  // Visual Inspection Report Download
  visualInspectionReportDownloadLoading: false,
  visualInspectionReportDownloadData: null,
  visualInspectionReportDownloadError: null,
  
  // Alignment Report Download
  alignmentReportDownloadLoading: false,
  alignmentReportDownloadData: null,
  alignmentReportDownloadError: null,
  
  // Production Sheet Merged Report Download
  productionSheetMergedReportDownloadLoading: false,
  productionSheetMergedReportDownloadData: null,
  productionSheetMergedReportDownloadError: null,
  
  // Production Sheet Main Report Download
  productionSheetMainReportDownloadLoading: false,
  productionSheetMainReportDownloadData: null,
  productionSheetMainReportDownloadError: null,
  
  // NDT Indication Log
  ndtIndicationLogs: [],
  ndtIndicationLogsLoading: false,
  ndtIndicationLogsError: null,
  createNDTRepairLogLoading: false,
  createNDTRepairLogError: null,
  createNDTRepairLogSuccess: false,
  updateNDTRepairLogLoading: false,
  updateNDTRepairLogError: null,
  updateNDTRepairLogSuccess: false,
  deleteNDTRepairLogLoading: false,
  deleteNDTRepairLogError: null,
  deleteNDTRepairLogSuccess: false,
  
  // NDT Repair Log Documents
  ndtRepairLogDocs: [],
  ndtRepairLogDocsLoading: false,
  ndtRepairLogDocsError: null,
  uploadNDTRepairLogDocLoading: false,
  uploadNDTRepairLogDocError: null,
  uploadNDTRepairLogDocSuccess: false,

  // NDT Indication Log Categories (filter dropdowns)
  ndtCategoryData: null,
  ndtCategoriesLoading: false,
  ndtCategoriesError: null,

  // Project Production Sheet Report Generation
  projectProductionSheetReportLoading: false,
  projectProductionSheetReportData: null,
  projectProductionSheetReportError: null,
  projectProductionSheetReportSuccess: false,
  // Generate Weld Report for Assembly
  generateReportAssemblyLoading: false,
  generateReportAssemblyData: null,
  generateReportAssemblyError: null,
  generateReportAssemblySuccess: false,
  
  // IRN Report Generation
  irnReportLoading: false,
  irnReportData: null,
  irnReportError: null,
  irnReportSuccess: false,
  irnReportVersionsLoading: false,
  irnReportVersions: {},
  irnReportVersionsError: null,
  
  // Production Report Versions
  productionReportVersionsLoading: false,
  productionReportVersions: {},
  productionReportVersionsError: null,

  // Generate Project Report
  generateProjectReportLoading: false,
  generateProjectReportSuccess: false,
  generateProjectReportError: null,

  // Project Report Versions
  projectReportVersionsLoading: false,
  projectReportVersions: [],
  projectReportVersionsError: null,

  // Delete Repair Weld
  deleteRepairWeldLoading: false,
  deleteRepairWeldData: null,
  deleteRepairWeldError: null,
  deleteRepairWeldSuccess: false,

  // Production Sheet Save Signature
  productionSheetSaveSignatureLoading: false,
  productionSheetSaveSignatureData: null,
  productionSheetSaveSignatureError: null,
  productionSheetSaveSignatureSuccess: false,

  // ARK Registry Documents
  arkRegistryDocs: [],
  arkRegistryDocsLoading: false,
  arkRegistryDocsError: null,
  arkRegistryDocsTotal: 0,
  uploadARKRegistryDocLoading: false,
  uploadARKRegistryDocError: null,
  uploadARKRegistryDocSuccess: false,
  deleteARKRegistryDocLoading: false,
  deleteARKRegistryDocError: null,
  deleteARKRegistryDocSuccess: false,
  arkRegistryDownloadUrl: null,
  arkRegistryDownloadUrlLoading: false,
  arkRegistryPresignedUrl: null,
  arkRegistryPresignedUrlLoading: false
};

const productionDataReducer = (state = initialState, action) => {
  switch (action.type) {
    // Assembly Data Cases
    case FETCH_ASSEMBLY_DATA:
      return {
        ...state,
        assemblyLoading: true,
        assemblyError: null
      };

    case SET_ASSEMBLY_DATA:
      return {
        ...state,
        assemblyData: action.assemblyData,
        assemblyTotalCount: action.assemblyTotalCount ?? action.assemblyData?.length ?? 0,
        assemblyLoading: false,
        assemblyError: null
      };

    case SET_ASSEMBLY_DATA_FAILURE:
      return {
        ...state,
        assemblyLoading: false,
        assemblyError: action.error
      };

    case CLEAR_ASSEMBLY_DATA:
      return {
        ...state,
        assemblyData: [],
        assemblyTotalCount: 0,
        assemblyError: null
      };

    // Assembly Details Cases
    case FETCH_ASSEMBLY_DETAILS:
      return {
        ...state,
        assemblyDetailsLoading: true,
        assemblyDetailsError: null
      };

    case SET_ASSEMBLY_DETAILS:
      return {
        ...state,
        assemblyDetails: {
          ...state.assemblyDetails,
          [action.assemblyDetails.assemblyNumber]: action.assemblyDetails
        },
        assemblyDetailsLoading: false,
        assemblyDetailsError: null
      };

    case SET_ASSEMBLY_DETAILS_FAILURE:
      return {
        ...state,
        assemblyDetailsLoading: false,
        assemblyDetailsError: action.error
      };

    case CLEAR_ASSEMBLY_DETAILS:
      return {
        ...state,
        assemblyDetails: {},
        assemblyDetailsError: null
      };

    // NDT Upload Cases
    case UPLOAD_NDT_DOCUMENT:
      return {
        ...state,
        ndtUploadLoading: true,
        ndtUploadError: null
      };

    case SET_NDT_UPLOAD_SUCCESS:
      return {
        ...state,
        assemblyData: state.assemblyData.map(assembly => 
          assembly.assemblyNumber === action.assemblyNumber
            ? { ...assembly, hasNDTDocument: true, ndtDocument: action.documentData }
            : assembly
        ),
        ndtUploadLoading: false,
        ndtUploadError: null
      };

    case SET_NDT_UPLOAD_FAILURE:
      return {
        ...state,
        ndtUploadLoading: false,
        ndtUploadError: action.error
      };

    // Assembly Status Update Cases
    case UPDATE_ASSEMBLY_STATUS:
      return {
        ...state,
        statusUpdateLoading: true,
        statusUpdateError: null,
        statusUpdateSuccess: false
      };

    case SET_ASSEMBLY_STATUS_SUCCESS:
      return {
        ...state,
        assemblyData: state.assemblyData.map(assembly => 
          assembly.assemblyNumber === action.assemblyNumber
            ? { ...assembly, status: action.status }
            : assembly
        ),
        statusUpdateLoading: false,
        statusUpdateError: null,
        statusUpdateSuccess: true
      };

    case SET_ASSEMBLY_STATUS_FAILURE:
      return {
        ...state,
        statusUpdateLoading: false,
        statusUpdateError: action.error,
        statusUpdateSuccess: false
      };

    // Assembly Filters Cases
    case FETCH_ASSEMBLY_FILTERS:
      return {
        ...state,
        filtersLoading: true,
        filtersError: null
      };

    case SET_ASSEMBLY_FILTERS:
      return {
        ...state,
        assemblyFilters: action.filters,
        filtersLoading: false,
        filtersError: null
      };

    case SET_ASSEMBLY_FILTERS_FAILURE:
      return {
        ...state,
        filtersLoading: false,
        filtersError: action.error
      };

    // Assembly Fitment Data Cases
    case UPDATE_ASSEMBLY_FITMENT:
      return {
        ...state,
        fitmentUpdateLoading: true,
        fitmentUpdateError: null,
        fitmentUpdateSuccess: false
      };

    case SET_ASSEMBLY_FITMENT_SUCCESS:
      return {
        ...state,
    
        fitmentUpdateLoading: false,
        fitmentUpdateError: null,
        fitmentUpdateSuccess: true
      };

    case SET_ASSEMBLY_FITMENT_FAILURE:
      return {
        ...state,
        fitmentUpdateLoading: false,
        fitmentUpdateError: action.error,
        fitmentUpdateSuccess: false
      };

    // Assembly Visual Inspection Data Cases
    case UPDATE_ASSEMBLY_VISUAL_INSPECTION:
      return {
        ...state,
        visualInspectionUpdateLoading: true,
        visualInspectionUpdateError: null,
        visualInspectionUpdateSuccess: false
      };

    case SET_ASSEMBLY_VISUAL_INSPECTION_SUCCESS:
      return {
        ...state,
        assemblyData: state.assemblyData.map(assembly => 
          assembly.assemblyNumber === action.assemblyNumber
            ? { ...assembly, visualInspectionData: action.visualInspectionData }
            : assembly
        ),
        visualInspectionUpdateLoading: false,
        visualInspectionUpdateError: null,
        visualInspectionUpdateSuccess: true
      };

    case SET_ASSEMBLY_VISUAL_INSPECTION_FAILURE:
      return {
        ...state,
        visualInspectionUpdateLoading: false,
        visualInspectionUpdateError: action.error,
        visualInspectionUpdateSuccess: false
      };

    // Assembly Alignment Data Cases
    case UPDATE_ASSEMBLY_ALIGNMENT:
      return {
        ...state,
        alignmentUpdateLoading: true,
        alignmentUpdateError: null,
        alignmentUpdateSuccess: false
      };

    case SET_ASSEMBLY_ALIGNMENT_SUCCESS:
      return {
        ...state,
        assemblyData: state.assemblyData.map(assembly => 
          assembly.assemblyNumber === action.assemblyNumber
            ? { ...assembly, alignmentData: action.alignmentData }
            : assembly
        ),
        alignmentUpdateLoading: false,
        alignmentUpdateError: null,
        alignmentUpdateSuccess: true
      };

    case SET_ASSEMBLY_ALIGNMENT_FAILURE:
      return {
        ...state,
        alignmentUpdateLoading: false,
        alignmentUpdateError: action.error,
        alignmentUpdateSuccess: false
      };

    // GPS Data Cases
    case FETCH_GPS_DATA:
      return {
        ...state,
        gpsLoading: true,
        gpsError: null
      };

    case SET_GPS_DATA:
      return {
        ...state,
        gpsData: action.gpsData,
        gpsLoading: false,
        gpsError: null
      };

    case SET_GPS_DATA_FAILURE:
      return {
        ...state,
        gpsLoading: false,
        gpsError: action.error
      };

    case CLEAR_GPS_DATA:
      return {
        ...state,
        gpsData: [],
        gpsError: null
      };

    // Production Data Cases
    case FETCH_PRODUCTION_DATA:
      return {
        ...state,
        productionDataLoading: true,
        productionDataError: null,
        productionDataSuccess: false
      };

    case SET_PRODUCTION_DATA:
      return {
        ...state,
        productionData: action.productionData,
        productionDataLoading: false,
        productionDataError: null,
        productionDataSuccess: true
      };

    case SET_PRODUCTION_DATA_FAILURE:
      return {
        ...state,
        productionDataLoading: false,
        productionDataError: action.error
      };

    case CLEAR_PRODUCTION_DATA:
      return {
        ...state,
        productionData: {},
        productionDataError: null,
        productionDataSuccess: false
      };

    // Team Members Cases
    case GET_ALL_TEAM_MEMBERS:
      return {
        ...state,
        teamMembersLoading: true,
        teamMembersError: null
      };

    case SET_TEAM_MEMBERS:
      return {
        ...state,
        teamMembers: action.payload || [],
        teamMembersLoading: false,
        teamMembersError: null
      };

    case SET_TEAM_MEMBERS_FAILURE:
      return {
        ...state,
        teamMembersLoading: false,
        teamMembersError: action.error
      };

    case CLEAR_TEAM_MEMBERS:
      return {
        ...state,
        teamMembers: [],
        teamMembersError: null
      };

    // Limits Data Cases
    case FETCH_LIMITS_DATA:
      return {
        ...state,
        limitsLoading: true,
        limitsError: null
      };

    case SET_LIMITS_DATA:
      return {
        ...state,
        limitsData: action.payload,
        limitsLoading: false,
        limitsError: null,
        // Extract statusCalculationMethod from projectData if available
        statusCalculationMethod: action.payload?.projectData?.statusCalculationMethod || 'Instantaneous'
      };

    case SET_LIMITS_DATA_FAILURE:
      return {
        ...state,
        limitsLoading: false,
        limitsError: action.error
      };

    case CLEAR_LIMITS_DATA:
      return {
        ...state,
        limitsData: [],
        limitsError: null
      };

    // Status Configuration Cases
    case UPDATE_STATUS_CONFIGURATION:
      return {
        ...state,
        statusConfigurationLoading: true,
        statusConfigurationError: null,
        statusConfigurationSuccess: false
      };

    case SET_STATUS_CONFIGURATION_SUCCESS:
      return {
        ...state,
        statusConfiguration: action.payload,
        statusConfigurationLoading: false,
        statusConfigurationError: null,
        statusConfigurationSuccess: true
      };

    case SET_STATUS_CONFIGURATION_FAILURE:
      return {
        ...state,
        statusConfigurationLoading: false,
        statusConfigurationError: action.error,
        statusConfigurationSuccess: false
      };

    // Weld Parameters Cases
    case FETCH_WELD_PARAMETERS:
      return {
        ...state,
        weldParametersLoading: true,
        weldParametersError: null
      };

    case SET_WELD_PARAMETERS:
      return {
        ...state,
        weldParameters: action.payload,
        weldParametersLoading: false,
        weldParametersError: null
      };

    case SET_WELD_PARAMETERS_FAILURE:
      return {
        ...state,
        weldParametersLoading: false,
        weldParametersError: action.error
      };

    case CLEAR_WELD_PARAMETERS:
      return {
        ...state,
        weldParameters: {},
        weldParametersError: null,
        weldParametersModalOpen: false,
        weldParametersMachineType: null
      };

    case SET_WELD_PARAMETERS_MODAL_OPEN:
      return {
        ...state,
        weldParametersModalOpen: action.payload.isOpen,
        weldParametersMachineType: action.payload.machineType
      };

    // Fitment Report Download Cases
    case DOWNLOAD_FITMENT_REPORT:
      return {
        ...state,
        fitmentReportDownloadLoading: true,
        fitmentReportDownloadError: null,
        fitmentReportDownloadData: null
      };

    case SET_FITMENT_REPORT_DOWNLOAD_SUCCESS:
      return {
        ...state,
        fitmentReportDownloadLoading: false,
        fitmentReportDownloadData: action.payload,
        fitmentReportDownloadError: null
      };

    case SET_FITMENT_REPORT_DOWNLOAD_FAILURE:
      return {
        ...state,
        fitmentReportDownloadLoading: false,
        fitmentReportDownloadError: action.error
      };

    case CLEAR_FITMENT_REPORT_DOWNLOAD:
      return {
        ...state,
        fitmentReportDownloadLoading: false,
        fitmentReportDownloadData: null,
        fitmentReportDownloadError: null
      };

    // Visual Inspection Report Download Cases
    case DOWNLOAD_VISUAL_INSPECTION_REPORT:
      return {
        ...state,
        visualInspectionReportDownloadLoading: true,
        visualInspectionReportDownloadError: null,
        visualInspectionReportDownloadData: null
      };

    case SET_VISUAL_INSPECTION_REPORT_DOWNLOAD_SUCCESS:
      return {
        ...state,
        visualInspectionReportDownloadLoading: false,
        visualInspectionReportDownloadData: action.payload,
        visualInspectionReportDownloadError: null
      };

    case SET_VISUAL_INSPECTION_REPORT_DOWNLOAD_FAILURE:
      return {
        ...state,
        visualInspectionReportDownloadLoading: false,
        visualInspectionReportDownloadError: action.error
      };

    case CLEAR_VISUAL_INSPECTION_REPORT_DOWNLOAD:
      return {
        ...state,
        visualInspectionReportDownloadLoading: false,
        visualInspectionReportDownloadData: null,
        visualInspectionReportDownloadError: null
      };

    // Alignment Report Download Cases
    case DOWNLOAD_ALIGNMENT_REPORT:
      return {
        ...state,
        alignmentReportDownloadLoading: true,
        alignmentReportDownloadError: null,
        alignmentReportDownloadData: null
      };

    case SET_ALIGNMENT_REPORT_DOWNLOAD_SUCCESS:
      return {
        ...state,
        alignmentReportDownloadLoading: false,
        alignmentReportDownloadData: action.payload,
        alignmentReportDownloadError: null
      };

    case SET_ALIGNMENT_REPORT_DOWNLOAD_FAILURE:
      return {
        ...state,
        alignmentReportDownloadLoading: false,
        alignmentReportDownloadError: action.error
      };

    case CLEAR_ALIGNMENT_REPORT_DOWNLOAD:
      return {
        ...state,
        alignmentReportDownloadLoading: false,
        alignmentReportDownloadData: null,
        alignmentReportDownloadError: null
      };

    // Production Sheet Merged Report Download Cases
    case DOWNLOAD_PRODUCTION_SHEET_MERGED_REPORT:
      return {
        ...state,
        productionSheetMergedReportDownloadLoading: true,
        productionSheetMergedReportDownloadError: null,
        productionSheetMergedReportDownloadData: null
      };

    case SET_PRODUCTION_SHEET_MERGED_REPORT_DOWNLOAD_SUCCESS:
      return {
        ...state,
        productionSheetMergedReportDownloadLoading: false,
        productionSheetMergedReportDownloadData: action.payload,
        productionSheetMergedReportDownloadError: null
      };

    case SET_PRODUCTION_SHEET_MERGED_REPORT_DOWNLOAD_FAILURE:
      return {
        ...state,
        productionSheetMergedReportDownloadLoading: false,
        productionSheetMergedReportDownloadError: action.error
      };

    case CLEAR_PRODUCTION_SHEET_MERGED_REPORT_DOWNLOAD:
      return {
        ...state,
        productionSheetMergedReportDownloadLoading: false,
        productionSheetMergedReportDownloadData: null,
        productionSheetMergedReportDownloadError: null
      };

    // Production Sheet Main Report Download Cases
    case DOWNLOAD_PRODUCTION_SHEET_MAIN_REPORT:
      return {
        ...state,
        productionSheetMainReportDownloadLoading: true,
        productionSheetMainReportDownloadError: null,
        productionSheetMainReportDownloadData: null
      };

    case SET_PRODUCTION_SHEET_MAIN_REPORT_DOWNLOAD_SUCCESS:
      return {
        ...state,
        productionSheetMainReportDownloadLoading: false,
        productionSheetMainReportDownloadData: action.payload,
        productionSheetMainReportDownloadError: null
      };

    case SET_PRODUCTION_SHEET_MAIN_REPORT_DOWNLOAD_FAILURE:
      return {
        ...state,
        productionSheetMainReportDownloadLoading: false,
        productionSheetMainReportDownloadError: action.error
      };

    case CLEAR_PRODUCTION_SHEET_MAIN_REPORT_DOWNLOAD:
      return {
        ...state,
        productionSheetMainReportDownloadLoading: false,
        productionSheetMainReportDownloadData: null,
        productionSheetMainReportDownloadError: null
      };

    // NDT Indication Log Cases
    case FETCH_NDT_INDICATION_LOGS:
      return {
        ...state,
        ndtIndicationLogsLoading: true,
        ndtIndicationLogsError: null
      };

    case SET_NDT_INDICATION_LOGS:
      return {
        ...state,
        ndtIndicationLogs: action.payload || [],
        ndtIndicationLogsLoading: false,
        ndtIndicationLogsError: null
      };

    case SET_NDT_INDICATION_LOGS_FAILURE:
      return {
        ...state,
        ndtIndicationLogsLoading: false,
        ndtIndicationLogsError: action.error
      };

    case CLEAR_NDT_INDICATION_LOGS:
      return {
        ...state,
        ndtIndicationLogs: [],
        ndtIndicationLogsError: null
      };

    // Create NDT Repair Log Cases
    case CREATE_NDT_REPAIR_LOG:
      return {
        ...state,
        createNDTRepairLogLoading: true,
        createNDTRepairLogError: null,
        createNDTRepairLogSuccess: false
      };

    case SET_CREATE_NDT_REPAIR_LOG_SUCCESS:
      return {
        ...state,
        ndtIndicationLogs: [...state.ndtIndicationLogs, action.payload],
        createNDTRepairLogLoading: false,
        createNDTRepairLogError: null,
        createNDTRepairLogSuccess: true
      };

    case SET_CREATE_NDT_REPAIR_LOG_FAILURE:
      return {
        ...state,
        createNDTRepairLogLoading: false,
        createNDTRepairLogError: action.error,
        createNDTRepairLogSuccess: false
      };

    // Update NDT Repair Log Cases
    case UPDATE_NDT_REPAIR_LOG:
      return {
        ...state,
        updateNDTRepairLogLoading: true,
        updateNDTRepairLogError: null,
        updateNDTRepairLogSuccess: false
      };

    case SET_UPDATE_NDT_REPAIR_LOG_SUCCESS:
      return {
        ...state,
        ndtIndicationLogs: state.ndtIndicationLogs.map(log =>
          log.id === action.payload.id ? action.payload : log
        ),
        updateNDTRepairLogLoading: false,
        updateNDTRepairLogError: null,
        updateNDTRepairLogSuccess: true
      };

    case SET_UPDATE_NDT_REPAIR_LOG_FAILURE:
      return {
        ...state,
        updateNDTRepairLogLoading: false,
        updateNDTRepairLogError: action.error,
        updateNDTRepairLogSuccess: false
      };

    // Delete NDT Repair Log Cases
    case DELETE_NDT_REPAIR_LOG:
      return {
        ...state,
        deleteNDTRepairLogLoading: true,
        deleteNDTRepairLogError: null,
        deleteNDTRepairLogSuccess: false
      };

    case SET_DELETE_NDT_REPAIR_LOG_SUCCESS:
      return {
        ...state,
        deleteNDTRepairLogLoading: false,
        deleteNDTRepairLogError: null,
        deleteNDTRepairLogSuccess: true
      };

    case SET_DELETE_NDT_REPAIR_LOG_FAILURE:
      return {
        ...state,
        deleteNDTRepairLogLoading: false,
        deleteNDTRepairLogError: action.error,
        deleteNDTRepairLogSuccess: false
      };

    // Fetch NDT Repair Log Documents Cases
    case FETCH_NDT_REPAIR_LOG_DOC:
      return {
        ...state,
        ndtRepairLogDocsLoading: true,
        ndtRepairLogDocsError: null
      };

    case SET_NDT_REPAIR_LOG_DOC:
      return {
        ...state,
        ndtRepairLogDocs: action.payload || [],
        ndtRepairLogDocsLoading: false,
        ndtRepairLogDocsError: null
      };

    case SET_NDT_REPAIR_LOG_DOC_FAILURE:
      return {
        ...state,
        ndtRepairLogDocsLoading: false,
        ndtRepairLogDocsError: action.error
      };

    // Upload NDT Repair Log Documents Cases
    case UPLOAD_NDT_REPAIR_LOG_DOC:
      return {
        ...state,
        uploadNDTRepairLogDocLoading: true,
        uploadNDTRepairLogDocError: null,
        uploadNDTRepairLogDocSuccess: false
      };

    case SET_NDT_REPAIR_LOG_DOC_SUCCESS:
      return {
        ...state,
        uploadNDTRepairLogDocLoading: false,
        uploadNDTRepairLogDocError: null,
        uploadNDTRepairLogDocSuccess: true
      };

    case CLEAR_NDT_REPAIR_LOG_DOC:
      return {
        ...state,
        ndtRepairLogDocs: [],
        ndtRepairLogDocsError: null
      };

    // NDT Indication Log Categories Cases
    case FETCH_NDT_CATEGORIES:
      return {
        ...state,
        ndtCategoriesLoading: true,
        ndtCategoriesError: null
      };

    case SET_NDT_CATEGORIES:
      return {
        ...state,
        ndtCategoryData: action.payload || null,
        ndtCategoriesLoading: false,
        ndtCategoriesError: null
      };

    case SET_NDT_CATEGORIES_FAILURE:
      return {
        ...state,
        ndtCategoriesLoading: false,
        ndtCategoriesError: action.error,
        ndtCategoryData: null
      };

    // Project Production Sheet Report Generation Cases
    case GENERATE_PROJECT_PRODUCTION_SHEET_REPORT:
      return {
        ...state,
        projectProductionSheetReportLoading: true,
        projectProductionSheetReportError: null,
        projectProductionSheetReportData: null,
        projectProductionSheetReportSuccess: false
      };

    case SET_PROJECT_PRODUCTION_SHEET_REPORT_SUCCESS:
      return {
        ...state,
        projectProductionSheetReportLoading: false,
        projectProductionSheetReportData: action.payload,
        projectProductionSheetReportError: null,
        projectProductionSheetReportSuccess: true
      };

    case SET_PROJECT_PRODUCTION_SHEET_REPORT_FAILURE:
      return {
        ...state,
        projectProductionSheetReportLoading: false,
        projectProductionSheetReportError: action.error,
        projectProductionSheetReportSuccess: false
      };

    case CLEAR_PROJECT_PRODUCTION_SHEET_REPORT:
      return {
        ...state,
        projectProductionSheetReportLoading: false,
        projectProductionSheetReportData: null,
        projectProductionSheetReportError: null,
        projectProductionSheetReportSuccess: false
      };

    case GENERATE_REPORT_ASSEMBLY:
      return {
        ...state,
        generateReportAssemblyLoading: true,
        generateReportAssemblyError: null,
        generateReportAssemblySuccess: false
      };

    case SET_GENERATE_REPORT_ASSEMBLY_SUCCESS:
      return {
        ...state,
        generateReportAssemblyLoading: false,
        generateReportAssemblyError: null,
        generateReportAssemblySuccess: true,
        generateReportAssemblyData: action.payload
      };

    case SET_GENERATE_REPORT_ASSEMBLY_FAILURE:
      return {
        ...state,
        generateReportAssemblyLoading: false,
        generateReportAssemblyError: action.error,
        generateReportAssemblySuccess: false,
        generateReportAssemblyData: null
      };

    case CLEAR_GENERATE_REPORT_ASSEMBLY:
      return {
        ...state,
        generateReportAssemblyLoading: false,
        generateReportAssemblyData: null,
        generateReportAssemblyError: null,
        generateReportAssemblySuccess: false
      };

    // IRN Report Generation Cases
    case GENERATE_IRN_REPORT:
      return {
        ...state,
        irnReportLoading: true,
        irnReportError: null,
        irnReportData: null,
        irnReportSuccess: false
      };

    case SET_IRN_REPORT_SUCCESS:
      return {
        ...state,
        irnReportLoading: false,
        irnReportData: action.payload,
        irnReportError: null,
        irnReportSuccess: true
      };

    case SET_IRN_REPORT_FAILURE:
      return {
        ...state,
        irnReportLoading: false,
        irnReportError: action.error,
        irnReportSuccess: false
      };

    case CLEAR_IRN_REPORT:
      return {
        ...state,
        irnReportLoading: false,
        irnReportData: null,
        irnReportError: null,
        irnReportSuccess: false
      };
    case GET_IRN_REPORT_VERSIONS:
      return {
        ...state,
        irnReportVersionsLoading: true,
        irnReportVersionsError: null
      };
    case GET_IRN_REPORT_VERSIONS_SUCCESS:
      return {
        ...state,
        irnReportVersionsLoading: false,
        irnReportVersions: action.payload,
        irnReportVersionsError: null
      };
    case GET_IRN_REPORT_VERSIONS_FAILURE:
      return {
        ...state,
        irnReportVersionsLoading: false,
        irnReportVersionsError: action.error,
        irnReportVersions: {}
      };

    // Production Report Versions Cases
    case GET_PRODUCTION_REPORT_VERSIONS:
      return {
        ...state,
        productionReportVersionsLoading: true,
        productionReportVersionsError: null
      };
    case GET_PRODUCTION_REPORT_VERSIONS_SUCCESS:
      return {
        ...state,
        productionReportVersionsLoading: false,
        productionReportVersions: action.payload,
        productionReportVersionsError: null
      };
    case GET_PRODUCTION_REPORT_VERSIONS_FAILURE:
      return {
        ...state,
        productionReportVersionsLoading: false,
        productionReportVersionsError: action.error,
        productionReportVersions: {}
      };

    // Generate Project Report Cases
    case GENERATE_PROJECT_REPORT:
      return {
        ...state,
        generateProjectReportLoading: true,
        generateProjectReportError: null,
        generateProjectReportSuccess: false
      };
    case GENERATE_PROJECT_REPORT_SUCCESS:
      return {
        ...state,
        generateProjectReportLoading: false,
        generateProjectReportSuccess: true,
        generateProjectReportError: null
      };
    case GENERATE_PROJECT_REPORT_FAILURE:
      return {
        ...state,
        generateProjectReportLoading: false,
        generateProjectReportError: action.error,
        generateProjectReportSuccess: false
      };
    case CLEAR_GENERATE_PROJECT_REPORT:
      return {
        ...state,
        generateProjectReportLoading: false,
        generateProjectReportError: null,
        generateProjectReportSuccess: false
      };

    // Get Project Report Versions Cases
    case GET_PROJECT_REPORT_VERSIONS:
      return {
        ...state,
        projectReportVersionsLoading: true,
        projectReportVersionsError: null
      };
    case GET_PROJECT_REPORT_VERSIONS_SUCCESS:
      return {
        ...state,
        projectReportVersionsLoading: false,
        projectReportVersions: action.payload,
        projectReportVersionsError: null
      };
    case GET_PROJECT_REPORT_VERSIONS_FAILURE:
      return {
        ...state,
        projectReportVersionsLoading: false,
        projectReportVersionsError: action.error,
        projectReportVersions: []
      };

    // Delete Repair Weld Cases
    case DELETE_REPAIR_WELD:
      return {
        ...state,
        deleteRepairWeldLoading: true,
        deleteRepairWeldError: null,
        deleteRepairWeldSuccess: false
      };

    case SET_DELETE_REPAIR_WELD_SUCCESS:
      return {
        ...state,
        deleteRepairWeldLoading: false,
        deleteRepairWeldData: action.payload,
        deleteRepairWeldError: null,
        deleteRepairWeldSuccess: true
      };

    case SET_DELETE_REPAIR_WELD_FAILURE:
      return {
        ...state,
        deleteRepairWeldLoading: false,
        deleteRepairWeldError: action.error,
        deleteRepairWeldSuccess: false,
        deleteRepairWeldData: null
      };

    case CLEAR_DELETE_REPAIR_WELD:
      return {
        ...state,
        deleteRepairWeldLoading: false,
        deleteRepairWeldData: null,
        deleteRepairWeldError: null,
        deleteRepairWeldSuccess: false
      };

    // Production Sheet Save Signature Cases
    case PRODUCTION_SHEET_SAVE_SIGNATURE:
      return {
        ...state,
        productionSheetSaveSignatureLoading: true,
        productionSheetSaveSignatureError: null,
        productionSheetSaveSignatureSuccess: false
      };

    case SET_PRODUCTION_SHEET_SAVE_SIGNATURE_SUCCESS:
      return {
        ...state,
        productionSheetSaveSignatureLoading: false,
        productionSheetSaveSignatureError: null,
        productionSheetSaveSignatureSuccess: true,
        productionSheetSaveSignatureData: action.payload
      };

    case SET_PRODUCTION_SHEET_SAVE_SIGNATURE_FAILURE:
      return {
        ...state,
        productionSheetSaveSignatureLoading: false,
        productionSheetSaveSignatureError: action.error,
        productionSheetSaveSignatureSuccess: false,
        productionSheetSaveSignatureData: null
      };

    case CLEAR_PRODUCTION_SHEET_SAVE_SIGNATURE:
      return {
        ...state,
        productionSheetSaveSignatureLoading: false,
        productionSheetSaveSignatureData: null,
        productionSheetSaveSignatureError: null,
        productionSheetSaveSignatureSuccess: false
      };

    // ARK Registry Documents Cases
    case FETCH_ARK_REGISTRY_DOCS:
      return {
        ...state,
        arkRegistryDocsLoading: true,
        arkRegistryDocsError: null
      };

    case SET_ARK_REGISTRY_DOCS:
      // Handle both array response and object with documents property
      const payloadData = action.payload;
      let documents = [];
      let total = 0;
      
      if (Array.isArray(payloadData)) {
        // If payload is directly an array
        documents = payloadData;
        total = payloadData.length;
      } else if (payloadData && typeof payloadData === 'object') {
        // If payload is an object with documents property
        documents = Array.isArray(payloadData.documents) ? payloadData.documents : [];
        total = payloadData.total || documents.length;
      }
      
      return {
        ...state,
        arkRegistryDocs: documents,
        arkRegistryDocsTotal: total,
        arkRegistryDocsLoading: false,
        arkRegistryDocsError: null
      };

    case SET_ARK_REGISTRY_DOCS_FAILURE:
      return {
        ...state,
        arkRegistryDocsLoading: false,
        arkRegistryDocsError: action.error
      };

    case UPLOAD_ARK_REGISTRY_DOC:
      return {
        ...state,
        uploadARKRegistryDocLoading: true,
        uploadARKRegistryDocError: null,
        uploadARKRegistryDocSuccess: false
      };

    case SET_ARK_REGISTRY_DOC_SUCCESS:
      return {
        ...state,
        uploadARKRegistryDocLoading: false,
        uploadARKRegistryDocError: null,
        uploadARKRegistryDocSuccess: true
      };

    case DELETE_ARK_REGISTRY_DOC:
      return {
        ...state,
        deleteARKRegistryDocLoading: true,
        deleteARKRegistryDocError: null,
        deleteARKRegistryDocSuccess: false
      };

    case SET_DELETE_ARK_REGISTRY_DOC_SUCCESS:
      return {
        ...state,
        deleteARKRegistryDocLoading: false,
        deleteARKRegistryDocError: null,
        deleteARKRegistryDocSuccess: true
      };

    case SET_DELETE_ARK_REGISTRY_DOC_FAILURE:
      return {
        ...state,
        deleteARKRegistryDocLoading: false,
        deleteARKRegistryDocError: action.error,
        deleteARKRegistryDocSuccess: false
      };

    case CLEAR_ARK_REGISTRY_DOCS:
      return {
        ...state,
        arkRegistryDocs: [],
        arkRegistryDocsTotal: 0,
        arkRegistryDocsError: null,
        uploadARKRegistryDocSuccess: false,
        deleteARKRegistryDocSuccess: false
      };

    case GET_ARK_REGISTRY_DOWNLOAD_URL:
      return {
        ...state,
        arkRegistryDownloadUrlLoading: true,
        arkRegistryDownloadUrl: null
      };

    case SET_ARK_REGISTRY_DOWNLOAD_URL:
      return {
        ...state,
        arkRegistryDownloadUrlLoading: false,
        arkRegistryDownloadUrl: action.payload
      };

    case GET_ARK_REGISTRY_PRESIGNED_URL:
      return {
        ...state,
        arkRegistryPresignedUrlLoading: true,
        arkRegistryPresignedUrl: null
      };

    case SET_ARK_REGISTRY_PRESIGNED_URL:
      return {
        ...state,
        arkRegistryPresignedUrlLoading: false,
        arkRegistryPresignedUrl: action.payload
      };

    default:
      return state;
  }
};

export default productionDataReducer; 